import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { DropletIcon, CreditCardIcon, ThermometerIcon } from 'lucide-react';
export function PainSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-24 bg-tactical-950 bg-noise relative" data-id="element-39">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-41">
          <p className="text-xl text-gray-300 leading-relaxed mb-10" data-id="element-42">
            La mayoría de la gente en la ciudad vive en una peligrosa ilusión de
            seguridad. Creen que el agua seguirá saliendo del grifo en el piso
            12, que los cajeros siempre darán billetes y que el supermercado se
            repondrá mágicamente cada noche.
          </p>

          <div className="bg-red-950/30 border border-red-900/50 rounded-lg p-6 mb-12 shadow-[inset_0_0_20px_rgba(220,38,38,0.05)]" data-id="element-43">
            <p className="text-2xl font-heading font-bold text-red-400 text-glow-red text-center tracking-wide" data-id="element-44">
              Pero si la logística se detiene solo 72 horas, la ciudad se
              convierte en una trampa de cemento.
            </p>
          </div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="space-y-6 mb-16" data-id="element-45">
          <motion.div variants={itemVariants} className="flex items-start gap-4 bg-tactical-900 p-6 rounded-lg border-l-4 border-red-600 shadow-lg" data-id="element-46">
            <div className="bg-red-950/50 p-3 rounded-full flex-shrink-0" data-id="element-47">
              <DropletIcon className="w-6 h-6 text-red-500" data-id="element-48" />
            </div>
            <p className="text-lg text-gray-200 font-medium pt-1" data-id="element-49">
              ¿Cómo subirás agua potable a tu hogar si las bombas eléctricas
              fallan?
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="flex items-start gap-4 bg-tactical-900 p-6 rounded-lg border-l-4 border-red-600 shadow-lg" data-id="element-50">
            <div className="bg-red-950/50 p-3 rounded-full flex-shrink-0" data-id="element-51">
              <CreditCardIcon className="w-6 h-6 text-red-500" data-id="element-52" />
            </div>
            <p className="text-lg text-gray-200 font-medium pt-1" data-id="element-53">
              ¿Cómo comprarás suministros básicos si las terminales de tarjeta
              dejan de funcionar?
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="flex items-start gap-4 bg-tactical-900 p-6 rounded-lg border-l-4 border-red-600 shadow-lg" data-id="element-54">
            <div className="bg-red-950/50 p-3 rounded-full flex-shrink-0" data-id="element-55">
              <ThermometerIcon className="w-6 h-6 text-red-500" data-id="element-56" />
            </div>
            <p className="text-lg text-gray-200 font-medium pt-1" data-id="element-57">
              ¿Cómo mantendrás la calma de tus hijos cuando el aire
              acondicionado se apague... de forma permanente?
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-58">
          <p className="text-xl text-gray-300 leading-relaxed" data-id="element-59">
            La parálisis por ansiedad es real. Ver las noticias y no saber qué
            comprar, qué guardar o cómo actuar es lo que separa a las víctimas
            de los{' '}
            <span className="font-bold text-cyan-accent text-glow-cyan uppercase tracking-wider" data-id="element-60">
              Centinelas
            </span>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}